import { useAuthBearerFetch } from "matsuri-hooks"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { m2mCleaning_cleanerV4 } from "@/endpoints/m2m-cleaning.cleaner-v4"
import { LatestGuestKeyboxNumberResponse } from "@/model/guestKeyboxNumber"

/**
 * ゲストキーボックスに現在設定されている番号を m2m-checkin（m2m-cleaning 経由）から取得する。
 * cleaningId が未指定（ツアーなど）の場合は取得しない。
 */
export const useLatestGuestKeyboxNumber = (
    cleaningId?: string
): LatestGuestKeyboxNumberResponse | undefined => {
    const { token } = useAuth()

    const endpoint = m2mCleaning_cleanerV4.getLatestGuestKeyboxNumber
    const { data } = useAuthBearerFetch<LatestGuestKeyboxNumberResponse>(
        token,
        cleaningId ? endpoint({ cleaningId }) : null,
        {
            method: endpoint.method
        }
    )

    return data
}
